import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M3.74093 4.97282L0.774033 1.91719C0.630986 1.76988 0.630986 1.5309 0.774033 1.38358L1.12013 1.02715C1.26302 0.879993 1.49446 0.879837 1.63766 1.02653L4 3.44823L6.3625 1.02668C6.5057 0.879836 6.73714 0.880151 6.88004 1.02731L7.22613 1.38374C7.36918 1.53105 7.36918 1.77003 7.22613 1.91735L4.25908 4.97282C4.11603 5.12014 3.88398 5.12014 3.74093 4.97282Z"
      fill="black"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const GrayDownArrow = memo(ForwardRef);
export default GrayDownArrow;
